import _replace from "ramda/src/replace";
import _endsWith from "ramda/src/endsWith";
import _curry from "ramda/src/curry";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _test from "ramda/src/test";
import { fromBase64 } from "../../browser/string";
import { serialize as serializeQuery } from "./querystring";
var DATA_URL_REGEXP = /^data:([^;,]+)?(?:;([^,]+))?,(.+)$/;
import * as _querystring from "./querystring";
export { _querystring as querystring };
export var isDataUrl = _test(DATA_URL_REGEXP);
export var parseDataUrl = function parseDataUrl(url) {
  var _DATA_URL_REGEXP$exec = DATA_URL_REGEXP.exec(url),
    _DATA_URL_REGEXP$exec2 = _slicedToArray(_DATA_URL_REGEXP$exec, 4),
    _ = _DATA_URL_REGEXP$exec2[0],
    _DATA_URL_REGEXP$exec3 = _DATA_URL_REGEXP$exec2[1],
    mediaType = _DATA_URL_REGEXP$exec3 === void 0 ? 'text/plain;charset=US-ASCII' : _DATA_URL_REGEXP$exec3,
    encoding = _DATA_URL_REGEXP$exec2[2],
    data = _DATA_URL_REGEXP$exec2[3];
  var decodedData = encoding === 'base64' ? fromBase64(data) : data;
  return {
    mediaType: mediaType,
    data: decodedData
  };
};
export var withQuery = _curry(function (query, url) {
  var querystring = serializeQuery(query);
  if (querystring) {
    return url.indexOf('?') !== -1 ? "".concat(url, "&").concat(querystring) : "".concat(url, "?").concat(querystring);
  }
  return url;
});
export var isWithinDomain = _curry(function (domain, url) {
  var _URL = new URL(url),
    hostname = _URL.hostname;
  return _endsWith(domain, hostname);
});
export var joinPathParts = _curry(function (left, right) {
  return "".concat(_replace(/\/+$/, '', left), "/").concat(_replace(/^\/+/, '', right));
});